var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketing-configure-page" },
    [
      _c("preloader", {
        staticClass: "marketing-configure-page__loader",
        attrs: { display: _vm.isLoading }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "marketing-configure-page__header" }, [
        _c(
          "div",
          {
            staticClass: "marketing-configure-page__header-logo",
            on: {
              click: function($event) {
                return _vm.goToUrl("/home")
              }
            }
          },
          [_c("CompassLogo", { attrs: { type: "logo", width: 100 } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "marketing-configure-page__content" }, [
        _c(
          "div",
          {
            staticClass:
              "marketing-configure-page__content-title typographies-display-medium"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Synchronisation de vos données")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "marketing-configure-page__content-informations typographies-paragraph-medium-regular"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__('En cliquant sur "Synchroniser" :')) +
                "\n            "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Une synchronisation automatique de certains champs utilisés dans vos autres modules se déclenchera. Vous aurez par la suite la possibilité de synchroniser d’autres champs depuis vos réglages Sellsy."
                      )
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Tous vos contacts liés à une société (ou un particulier) seront synchronisés. Vous les retrouverez dans votre module marketing, et ils se mettront à jour quotidiennement."
                      )
                    ) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Notez que chaque collaborateur ayant accès au module marketing aura connaissance de tous les contacts synchronisés."
                  )
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "marketing-configure-page__content-buttons" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.synchronise"),
                size: "large"
              },
              on: { click: _vm.configureAccount }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }